<template>
  <div class="empty-playlist text-center">
    <div class="mb-16 mx-auto flex flex-col text-center">
      <h3 class="mb-8 font-semibold text-2xl">
        Es wurden noch keine Lieder zur Playlist hinzugefügt
      </h3>
      <div>
        <router-link
          :to="{ name: 'event.track.search', params: { id: routeId } }"
          tag="mj-button"
          class="btn-primary"
          v-text="'Playlist befüllen'"
        />
      </div>
    </div>
    <mj-icon
      src="empty-playlist"
      class="w-2/4 h-auto"
      proportions="rectangle"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
      routeId: null,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.id) {
          this.routeId = route.params.id;
        }
      },
    },
  },
};

</script>
